<div class="main-menu-wrapper">
  <div class="scroll-menu">
    <div class="user-info d-flex align-items-center" *ngIf="userInfo">
      <div class="user-icon mr-3 text-primary">{{ userInfo.inicials }}</div>
      <div class="user-info-strings">
        <div class="user-name text-primary">{{ userInfo.name }}</div>
        <div class="role">{{ userInfo.role | translate }}</div>
      </div>
    </div>

    <div class="m-menu">
      <div *ngFor="let menu of mainMenu" class="menu">
        <div
          class="menu-with-sub"
          *ngIf="menu.links && menu.links.length > 0; else singleMenu"
          routerLinkActive="active-submenu"
          [routerLinkActiveOptions]="{ exact: false }"
        >
          <div class="d-flex" (click)="parentMenuClick(menu); menu.action ? menu.action() : null" (keyup.enter)="parentMenuClick(menu); menu.action ? menu.action() : null" tabindex="0">
            <div class="icon"><i class="{{ menu.icon }}"></i></div>
            <div>{{ menu.heading | translate }}</div>
            <div class="ml-auto">
              <i class="fa-solid fa-chevron-down" [hidden]="menu.open"></i>
              <i class="fa-solid fa-chevron-up" [hidden]="!menu.open"></i>
            </div>
          </div>

          <div class="sub-menu" [hidden]="!menu.open">
            @for (subMenu of menu.links; track (subMenu.heading + '-' + (subMenu.link || '') + '-' + $index)) {
              @if (subMenu.link && subMenu.link.startsWith('http')) {
                <a
                  [href]="subMenu.link"
                  (click)="menuClick(subMenu)"
                  target="_blank"
                >
                  <div class="sub-menu-link d-flex align-items-center">
                    <div class="icon"><i class="{{ subMenu.icon }}"></i></div>
                    <div>{{ subMenu.heading | translate }}</div>
                  </div>
                </a>
              } @else {
                <a
                  [routerLink]="subMenu.link ? [subMenu.link] : null"
                  (click)="menuClick(subMenu)"
                  routerLinkActive="active"
                >
                  <div class="sub-menu-link d-flex align-items-center">
                    <div class="icon"><i class="{{ subMenu.icon }}"></i></div>
                    <div>{{ subMenu.heading | translate }}</div>
                  </div>
                </a>
              }
            }
          </div>
        </div>
        <ng-template #singleMenu>
          @if (menu.heading !== 'HIDE_PRICE') {
            <a [routerLink]="menu.link ? [menu.link] : null" (click)="menuClick(menu)" routerLinkActive="active">
              <div class="single-menu d-flex align-items-center">
                <div class="icon"><i class="{{ menu.icon }}"></i></div>
                <div>{{ menu.heading | translate }}</div>
              </div>
            </a>
          } @else if (menu.heading === 'HIDE_PRICE') {
            <div class="d-flex">
              <div class="icon"><i class="{{ menu.icon }}"></i></div>
              <div class="gung-toggle-switch">
                <label class="switch">
                  <input
                    id="hidePrice"
                    name="hidePrice"
                    type="checkbox"
                    #hidePriceInput
                    (change)="menu.action(hidePriceInput)"
                  />
                  <span class="slider round bg-primary"></span>
                </label>
                <label for="hidePrice" class="ml-1" translate>{{ menu.heading }}</label>
              </div>
            </div>
          }
        </ng-template>
        <div class="separator"></div>
      </div>
    </div>
  </div>

  <div class="logout">
    <gung-button
      classes="btn-primary w-100"
      label="{{ 'LOGOUT' | translate }}"
      icon="fa-solid fa-right-to-bracket"
      [onClick]="logout.bind(this)"
    />
  </div>
</div>
